<template>
    <div>
    <TextBanner>
        Das Konzept: eine neue, moderne Schutzhülle, genannt <strong>New Safe Confinement</strong>. Die Stahlkonstruktion
        wird 2016 fertiggestellt- nach fünf Jahren Bauzeit. Sie soll den Beton-Sarkophag und das darin enthaltene radioaktive Material für
        <strong>bis zu 100 Jahre </strong> von der Umwelt sicher isolieren.

    </TextBanner>

        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/07_NSC_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/07_NSC_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          	
        </Fallback>

    </div>
</template>



<script>
    export default {
        name: 'NSC',
        babylonState: {
            moveCamera: [-8, 1.4, 9.5, 27 ,0.4,1.5],    

            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_startpos: true,
                    Geo_Schattenplane_NSC_startpos: true,
                    Geo_Schienen_Sarkophag: true,

                    Geo_Typo_2016: true,
                    

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            this.$babylonController.setClipping(0.2, 20000);

            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (3,20),
            this.$babylonController.zoomCamera(2.1)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
